export default function SocialProofBar() {
  return (
    <div className="bg-gray-50 border-y border-gray-200">
      <div className="container mx-auto px-4 py-4">
        <p className="text-center text-sm md:text-base text-gray-600">
          Trusted by 1,000+ businesses • 50,000+ forms processed •{' '}
          <span className="inline-flex items-center">
            <span className="text-yellow-500">⭐⭐⭐⭐⭐</span>
            <span className="ml-1">4.9/5 rating</span>
          </span>
        </p>
      </div>
    </div>
  );
}
